
export enum FmsSecCntr {
    // OIM
    OIMblHold = "OI_MBL_Hold",

    // OIH
    OIHblNomi = "OI_HBL_Nomi",
    OIHblFree = "OI_HBL_Free",
    OIHblCoLoad = "OI_HBL_CoLoad",
    OIHblExpressRelease = "OI_HBL_ExpressRelease",
    OIHblOBLReceived = "OI_HBL_OBLReceived",
    OIHblOBLReceivedDate = "OI_HBL_OBLReceivedDate",
    OIHblReleased = "OI_HBL_Released",
    OIHblReleasedBy = "OI_HBL_ReleasedBy",
    OIHblReleasedDate = "OI_HBL_ReleasedDate",
    OIHblSalesperson = "OI_HBL_Salesperson",

    // OEH
    OEHblSalesperson = "OE_HBL_Salesperson",

    // AIH
    AIHblSalesperson = "AI_HAWB_Salesperson",

    // AEH
    AEHblSalesperson = "AE_HAWB_Salesperson",

    // Other Shipment
    OtherShipmentSalesperson = "OtherShipment_Salesperson",

    // General Invoice
    GInvGiveCredit = "GInv_GiveCredit",
    GInvCancelCredit = "GInv_CancelCredit",
    GInvConfirmed = "GInv_Confirmed",

    //Storage Invoice
    STInvConfirmed = "STInv_Confirmed",

    // Invoice
    InvGivCredit = "Inv_GiveCredit",
    InvCancelCredit = "Inv_CancelCredit",
    InvConfirmed = "Inv_Confirmed",

    // General Bill
    GBillGivCredit = "GBill_GiveCredit",
    GBillCancelCredit = "GBill_CancelCredit",
    GBillConfirmed = "GBill_Confirmed",

    // Bill
    BillGivCredit = "Bill_GiveCredit",
    BillCancelCredit = "Bill_CancelCredit",
    BillConfirmed = "Bill_Confirmed",

    // Crdb
    CrDbConfirmed = "CrDb_Confirmed",


    //warehousing
    WHInvConfirmed = "WHInv_Confirmed",
	WHBillConfirmed = "WHBill_Confirmed",
	WHCrDbConfirmed = "WHCrDb_Confirmed",


    
    // Company
    ComAutoBillingRate = "Com_AutoBillingRate",
    ComCreditLimit = "Com_CreditLimit",
    ComCreditTerms = "Com_CreditTerms",
    ComCustomerServiceRep = "Com_CustomerServiceRep",
    ComSalesperson = "Com_SalesPerson",
    ComCreditHold = "Com_CreditHold",
    ComFullName = "Com_FullName",
    ComInactive = "Com_Inactive",
    ComShortName = "Com_ShorName",

    // Tool
    MemoEdit = "Memo_Edit",
    MemoDelete = "Memo_Delete",

    // Payment
    BillPaymentVoid = "BillPayment_Void",

    // Aging
    AcctARAging = "Acct_AR_Aging",
    AcctAPAging = "Acct_AP_Aging",
    AcctARAPAging = "Acct_AR_AP_Aging",
    AcctARAgentAging = "Acct_AR_Agent_Aging",
    AcctAPAgentAging = "Acct_AP_Agent_Aging",
    AcctAgentAging = "Acct_Agent_Aging",
    AcctReceivableAging = "Acct_Receivable_Aging",
    AcctPayableAging = "Acct_Payable_Aging",
    AcctReceivablePayableAging = "Acct_Receivable_Payable_Aging",
    AcctCheckReceivableAging = "Acct_Check_Receivable_Aging",
    AcctCheckPayableAging = "Acct_Check_Payable_Aging",
    AcctCheckReceivablePayableAging = "Acct_Check_Receivable_Payable_Aging",
    AcctCreditCardPayableAging = "Acct_CreditCard_Payable_Aging",
    AcctAcctARAPAgentAging = "Acct_AR_AP_Agent_Aging",
}
